import { styled } from '@clickcease/cc-client-components-lib'

export const BzSetupPopupStyled = styled('div', {})

export const BzSetupPopupContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  padding: '$12',
  paddingBottom: '80px', // to make space for footer with absolute position
})

export const BzSetupPopupSteps = styled('ul', {
  display: 'flex',
  flexDirection: 'column',
  listStyleType: 'decimal',
  fontSize: '$md',
  fontWeight: '$l',
  padding: '0px 0px $7 $8',
  margin: 0,
  lineHeight: '24px',
})

export const BzSetupPopupStep = styled('li', {})

export const KeysTitleRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '18px',
})

export const BzInstructionsLink = styled('a', {
  cursor: 'pointer',
  fontWeight: '$r',
  marginLeft: '2px',
  textDecoration: 'underline',
  color: '$black',
})
export const BzSetupPopupInstallationKeys = styled('div', {
  width: '468px',
  border: '1px solid #EFEFEF',
  boxShadow: '0px 0px 30px rgba(102, 102, 102, 0.05)',
  borderRadius: '12px',
  padding: '$10',
})

export const BzSetupPopupInstallationKeysTitle = styled('div', {
  fontWeight: '$r',
  fontSize: 'md',
})
